module.exports = __webpack_public_path__ + "static/img/akum_600_200.027145b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_600_200.svg
// module id = XYNw
// module chunks = 1